import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import * as projMsgs from '../../../../../src/app/msg/projMsgs';
import { mainMapMngr } from '../../../../core/app/asp/MapMngr';
import { AppInjector } from '@core_n/common/inject';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as utils from '../../common/utils';
import { MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MsgMngrService } from '../../msg/msg-mngr.service';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';import { Animations } from '@core_n/Animations';
import { aspMngr } from '../../asp/AspMngr';
import { userSettings } from '@core_n/common/settings';
import { dialogType } from '@core_n/enums';

@Component({
  selector: 'app-playback-dialog',
  templateUrl: './playback-dialog.component.html',
  styleUrls: ['./playback-dialog.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class PlaybackDialogComponent extends ZIndexMngr implements OnInit, AfterViewInit {

  selectedDate: Date | null = null; //Holds the selected date
  currentDateTime: Date | null = null;
  availableDates: number[] = [];
  isPlaybackStatus: boolean = false;
  isAvaiableDate: boolean;
  availableDate: Date | null = null;
  
  constructor(
    private datePipe: DatePipe,
    private msgMngrService: MsgMngrService,
    private msgBoxService: MsgBoxService,
    public dialogRef: MatDialogRef<PlaybackDialogComponent>,
    elementRef: ElementRef,)  {
      super(elementRef);
    };

  static createDialogConfig(top: number, left: number) {
    return utils.createDialogConfig(false, false, dialogType.PlaybackMode,
      { top: `${top + 10}px`, left: `${left + 10}px` });
  }

    ngOnInit(): void {
      this.selectedDate = new Date();
      this.currentDateTime = new Date();
      userSettings.isPlayback.subscribe(status => {
        this.isPlaybackStatus = status;
      });
          
      //*** Send switch action to get available dates from server  ***//

      // // For tests
      // const dummyDates = [
      //   "2024-12-02T00:00:00",
      //   "2024-12-03T00:00:00",
      //   "2024-12-04T00:00:00"
      //    ];
      //  const formattedDates = dummyDates.map(date => new Date(date).getTime());
      //  this.availableDates = formattedDates.map(d => Math.floor(d / 1000));
      //  console.log(` initialized availableDates: ${this.availableDates} `);
      //  console.log(` is avalable in Array? ${Array.isArray(this.availableDates)}`)
    }

    ngAfterViewInit(): void {
      setTimeout(() => {
        this.windowVisible.next(true);
      })
    }

     sendPlaybackRequest(date: Date) {   
      if(date){  
        let Msg = new projMsgs.StartPlaybackMode();
        Msg.dateTime = date.getTime() / 1000;
        AppInjector.get(UserActionService).sendUserAction(Msg); 
        console.log(`Playback Time requested : ${date}`);  
        this.dialogRef.close();
        if(userSettings.isPlayback){
          userSettings.playbackTime.next(date);
          aspMngr.deleteAllObjects();
          mainMapMngr.clearObjects();
        }
      }
    }  

    onDateSelected(newDate: Date) {    
      this.selectedDate = newDate;
      console.log(`User selected playback date: ${this.selectedDate}`);
      this.sendPlaybackRequest(this.selectedDate);
    }

//     highlightAvailableDates(){     
//       //Find all calender cells
//       const cells = document.querySelectorAll('td[aria-label]');
//       cells.forEach((cell) =>{
//          const ariaLabel = cell.getAttribute('aria-label'); // Get the date from aria label
//          if(ariaLabel){  
//            // Note that ariaLabel holds date format like '4 decemnber 2024' so the time by default is '00:00:00'    
//            const dateString =  Math.floor(new Date(ariaLabel).getTime() / 1000);
//            if(this.availableDates.includes(dateString)) {
//              cell.classList.add('available');  // If Date available add the CSS class
//            }              
//          } 
//       });
//     }

    onDatePickerOpen(){
      // let Msg = new projMsgs.PlaybackAvailableDates;
      // AppInjector.get(UserActionService).sendUserAction(Msg); 
      // console.log(`Playback available dates  requested...`);  
      //setTimeout(() => this.highlightAvailableDates(),10);
    }
}
